/*!
 *  (c)(r) 2008-2021 IT-Service Robert Frunzke
 */


export let MDLocaleBase = function() {

	var m_impl = null;

	// real thin space (in browser: when copying text containing this kind of space, a real space character is copied)
	var real_thinspace_x = '<span style="margin-left:0.167em"><span style="display:none">&nbsp;</span></span>';

	// NOTE: dont (yet) import this from ../util.js, for reasons ...
	function _clip( n, lower, upper ) {
		return Math.max(lower,Math.min(n,upper));
	}

	function fmt_filesize( s, plain_text, multiplier, significant_digits ) {
		if( typeof(multiplier)==='undefined' ) multiplier = 1024;
		if( typeof(significant_digits)==='undefined' ) significant_digits = 2;
		var sdm = Math.pow(10,_clip(significant_digits,0,8)),
			e = 'B';
		if( s >= multiplier ) {
			s = Math.round( sdm * s / multiplier ) / sdm;
			e = 'kB';
		}
		if( s >= multiplier ) {
			s = Math.round( sdm * s / multiplier ) / sdm;
			e = 'MB';
		}
		if( s >= multiplier ) {
			s = Math.round( sdm * s / multiplier ) / sdm;
			e = 'GB';
		}
		if( s >= multiplier ) {
			s = Math.round( sdm * s / multiplier ) / sdm;
			e = 'TB';
		}
		return m_impl.fmt_number(s) + (plain_text?'':real_thinspace_x) + e;
	}

	function fmt_interval(iv) {
		// HH:mm:ss
		if( iv.length==8 && iv.match(/^\d\d:\d\d:\d\d$/) ) {
			var h = parseInt(iv.substr(0,2),10);
			// QUIRK: we currently just ignore minutes & seconds here
			return h+'h';
		}
		if( iv=='1 day' ) return '1d';
		if( iv.match(/^\d+ days$/) ) return parseInt(iv,10)+'d';
		// other/unknown interval syntax
		return iv;
	}

	// start with a non-localized default
	var localized_string_compare = function( a, b ) {
		return a.localeCompare(b);
	};

	return {
		init_with_impl: function( impl ) {
			m_impl = impl;
			localized_string_compare = impl.localized_string_compare;
		},
		get_impl: function() {
			return m_impl;
		},
		fmt_filesize: fmt_filesize,
		fmt_interval: fmt_interval,
		localized_string_compare: localized_string_compare,
		real_thinspace_x: real_thinspace_x,
	};
}(); // namespace MDLocaleBase

